import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { ErrorMessagesReducerStoreService } from '../../store/services/error-message.reducer.service';
import { ValidationMessages } from './validation-messages';

@Component({
  selector: 'ngc-validation-error-message',
  templateUrl: 'validation-error-message.component.html'
})
export class ValidationErrorMessageComponent implements OnInit, OnDestroy {
  @Input() index: number;
  /**
   * Pass the UntypedFormControl or UntypedFormGroup for which the message has to be shown
   *
   * @type {AbstractControl}
   * @memberof ValidationErrorMessageComponent
   */
  @Input() control: AbstractControl;
  /**
   * Pass the UntypedFormControl or UntypedFormGroup for which the message has to be shown
   *
   * @type {string}
   * @memberof ValidationErrorMessageComponent
   */
  @Input() controlname: string;

  /**
   * Pass true if the error has to be shown as soon as input value changes.
   *
   * @type {boolean}
   * @memberof ValidationErrorMessageComponent
   */
  @Input() showErrorOnChange = false;

  /**
   * Pass this for when you want the error message to be shown
   *
   * @type {string}
   * @memberof ValidationErrorMessageComponent
   */
  @Input() makeVisible: boolean;

  /**
   * Pass the id of the element for which this message has to be read. Also the element for which the MakeCorrectionComponent should focus.
   *
   * @type {string}
   * @memberof ValidationErrorMessageComponent
   */
  @Input() focusedFieldId: string;
  errorServiceErrorMessagesSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();
  private errorJSON: any;

  constructor(
    private errorService: ErrorMessagesReducerStoreService,
    private loggingService: LoggingService
  ) {}

  get errorMessage() {
    for (const propertyName in this.control.errors) {
      if (
        this.control.errors.hasOwnProperty(propertyName) &&
        (this.control.touched || this.showErrorOnChange)
      ) {
        return this.getMessageFromKey(
          propertyName,
          this.controlname,
          this.control.errors[propertyName]
        );
      }
    }
    if (
      this.control instanceof UntypedFormGroup &&
      this.control.errors == null
    ) {
      for (const controlName in this.control.controls) {
        if (controlName) {
          const childcontrol = this.control.controls[controlName];
          if (childcontrol) {
            for (const propertyName in childcontrol.errors) {
              if (
                childcontrol.errors.hasOwnProperty(propertyName) &&
                childcontrol.touched
              ) {
                return this.getMessageFromKey(
                  propertyName,
                  this.controlname,
                  childcontrol.errors[propertyName]
                );
              }
            }
          }
        }
      }
    }
    return null;
  }

  get controlName() {
    return this.controlname === null ? '' : this.controlname;
  }

  get getId() {
    if (this.index >= 1 && this.controlName === 'departureDate') {
      return this.controlName + '-error' + this.index;
    } else {
      return this.controlName + '-error';
    }
  }

  public get shouldShow() {
    const shdshow: boolean =
      this.control &&
      (this.control.touched || this.showErrorOnChange) &&
      !this.control.valid &&
      this.makeVisible &&
      this.errorMessage != null;
    if (this.controlName === 'departureDate') {
      const focusdepElm = document.querySelector('#' + this.focusedFieldId);
      const focusretElm = document.querySelector(
        '#input_returnDate_' + this.index
      );
      if (focusdepElm) {
        if (shdshow) {
          focusdepElm.setAttribute('aria-invalid', 'true');
        } else {
          focusdepElm.setAttribute('aria-invalid', 'false');
        }
      } else if (focusretElm) {
        if (shdshow) {
          focusretElm.setAttribute('aria-invalid', 'true');
        } else {
          focusretElm.setAttribute('aria-invalid', 'false');
        }
      }
    }
    return shdshow;
  }

  ngOnInit() {
    this.errorServiceErrorMessagesSubscribe =
      this.errorService.errorMessages.subscribe(
        (data) => {
          if (data) {
            if (data.errorMessages) {
              this.errorJSON = data.errorMessages;
            }
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
  }

  getMessageFromKey(
    validatorName: string,
    fieldname: string,
    validatorValue?: any
  ) {
    const key = ValidationMessages.getInstance().getValidatorErrorMessage(
      validatorName,
      fieldname,
      validatorValue
    );
    if (key) {
      if (this.errorJSON) {
        const errormsgobj = this.errorJSON.get(key);
        if (errormsgobj) {
          return errormsgobj.errorMessageTitle;
        }
      }
      return key;
    }
    return null;
  }

  ngOnDestroy() {
    if (this.errorServiceErrorMessagesSubscribe) {
      this.errorServiceErrorMessagesSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }
}
